import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/connected-apps/new/loading';

export const Route = createFileRoute('/_private/connected-apps/new')({
  pendingComponent: Loading,
});
